import { KuposInput } from '../../../common';
import React from 'react';

function Steps(props) {
  return (
    <div className="recharge-steps-outer">
      <div className="inputs">
        <div className="title bold-text font10">{props.t('PROFILE.RECHARGE_AMOUNT')}</div>
        <KuposInput
          placeholder="$XXXXX"
          className="kupos-border font10"
          value={props.rechargeAmount}
          onBlur={() => {}}
          onChange={val => props.onRechargeAmountChange(val)}
          error={props.amountError ? true : false}
          errorMessage={props.amountError ? props.amountError.message : ''}
        />
        <div className="button-container font12">
          <button
            className="kupos-button"
            disabled={props.data.walletRechargePending}
            onClick={props.rechargeRequest}
          >
            {props.data.walletRechargePending ? (
              <div className="loader-cricle"></div>
            ) : (
              <span>{props.t('HOME.RECHARGE')}</span>
            )}
          </button>
        </div>
      </div>
      <div className="steps">
        <div className="title bold-text font10">{props.t('PROFILE.HOW_TO_RECHARGE')}</div>

        <div className="wallet-recharge-extra-items">
          <div>
            <div className="kupos-card" style={{ height: 145 }}>
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 1</span>
                <img src="/images/icon_kupos_wallet.png" alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.ENTER_RECHARGE_AMOUNT')}</span>
            </div>

            <div className="kupos-card">
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 3</span>
                <img src="/images/circular/rut.png" alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.SHARE_RUT_AGENT')} </span>
            </div>
          </div>
          <div>
            <div className="kupos-card" style={{ height: 145 }}>
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 2</span>
                <img src="/images/circular/house.png" alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.FIND_REC_POINT')}</span>
              <span
                onClick={props.showMap}
                className="font8 primary-text"
                style={{ marginTop: -5, cursor: 'pointer' }}
              >
                {props.t('PROFILE.REC_POINT_LINK')}
              </span>
            </div>

            <div className="kupos-card">
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 4</span>
                <img src="/images/circular/ticket.png" alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.FIVE_MIN_MONEY')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Steps;



// WEBPACK FOOTER //
// ./src/features/my-account/RechargeWalletKupospayRecharge/components/Steps.js